import { gitInfo } from '@/app/version';

//------------------------------------------------------------------------------
// move to .env
// export const restDevApiUrl = '';
// export const restRelApiUrl = '';

export const tokens = {
  // system: tokenSystem,
  // root: tokenRoot,
  admin: import.meta.env.VITE_SYSTEM_TOKEN,
};

export function getApiUrl() {
  if(gitInfo.branch === "master" || gitInfo.branch === "hotfix") {
      return import.meta.env.VITE_API_BASE_PROD_URL
  } else if(gitInfo.branch === "uat") {
      return import.meta.env.VITE_API_BASE_UAT_URL
  } else {
      return import.meta.env.VITE_API_BASE_URL
  }
}
